import type React from 'react';
import styles from './tabs.module.scss';
import { panelId, tabId, useWordsHappenTabsContext } from './tabs-context';

export interface WordsHappenTabProps {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  /** Matches the WordsHappenTabPanel it shows. */
  value: string;
}

/** One tab. Only the selected tab is in the Tab order; the arrow keys reach the others. */
export const WordsHappenTab: React.FC<WordsHappenTabProps> = ({ children, className, disabled = false, value }) => {
  const { activeValue, baseId, setActiveValue } = useWordsHappenTabsContext();
  const selected = activeValue === value;

  return (
    <button
      type="button"
      role="tab"
      id={tabId(baseId, value)}
      aria-selected={selected}
      aria-controls={panelId(baseId, value)}
      aria-disabled={disabled || undefined}
      tabIndex={selected ? 0 : -1}
      className={[styles.tab, className].filter(Boolean).join(' ')}
      onClick={() => {
        if (!disabled) {
          setActiveValue(value);
        }
      }}
    >
      {children}
    </button>
  );
};
